import {
  TX_CLOCK_DCD, TX_DCD, TX_PJ_AMPLITUDE, TX_PJ_FREQUENCY, TX_JITTER_PDF,
  RX_SJ_AMPLITUDE, RX_AMPLITUDE_NOISE, RX_JITTER_PDF,
  TX_SJ, TX_DJ, TX_RJ, TX_SJ_FREQUENCY,
  RX_SJ, RX_DJ, RX_RJ, RX_NOISE, RX_DCD,
  RANDOM, DJRJ, DUAL_DIRAC
} from "../../ADS/constant";

const MAXIMAL_LENGTH_LFSR = "0", USER_DEFINED_LFSR = "1", USER_DEFINED_SEQUENCE = "2",
  JITTER_PDF_NONE = "None",
  REGISTER_LENGTH = "registerLength", TAPS = "taps", SEED = "seed", BIT_SEQUENCE = "bitSequence";

const JITTER_PDF_LIST = [
  {
    key: JITTER_PDF_NONE,
    list: []
  },
  {
    key: RANDOM,
    list: ["Sigma"]
  },
  {
    key: DJRJ,
    list: ["Sigma", "Min", "Max"]
  },
  {
    key: DUAL_DIRAC,
    list: ["Sigma", "Mean1", "Mean2"]
  }];

function getJitterEQDefaultValue(name) {
  switch (name) {
    case TX_DCD:
    case TX_CLOCK_DCD:
    case RX_SJ_AMPLITUDE:
    case TX_SJ:
    case TX_DJ:
    case TX_RJ:
    case RX_SJ:
    case RX_DJ:
    case RX_RJ:
    case RX_DCD:
      return { name, unit: "UI", value: "0" }
    case TX_SJ_FREQUENCY:
    case RX_NOISE:
      return { name, value: "0" }
    case TX_PJ_AMPLITUDE:
      return { name, unit: "ps", value: "0" }
    case TX_PJ_FREQUENCY:
      return { name, unit: "MHz", value: "100" }
    case TX_JITTER_PDF:
    case RX_JITTER_PDF:
      return { name, type: JITTER_PDF_NONE }
    case RX_AMPLITUDE_NOISE:
      return { name, unit: "V", value: "0" }
    default:
      return "0";
  }
}

function getTitleFromValue(key, value) {
  let title = ""
  switch (key) {
    case 'mode':
      if (value === MAXIMAL_LENGTH_LFSR) {
        return "Maximal Length LFSR"
      } else if (value === USER_DEFINED_LFSR) {
        title = 'User Defined LFSR'
      } else if (value === USER_DEFINED_SEQUENCE) {
        title = 'User Defined Sequence'
      }
      break;
    default:
      title = value.toString()
      break
  }
  return title;
}

const NONE = "None", FSEC = "fs", PSEC = "ps", NSEC = "ns", USEC = "us", MSEC = "ms", SEC = "s";
const adsDelayList = [{ value: NONE, label: 'None' },
{ value: FSEC, label: 'fs' },
{ value: PSEC, label: 'ps' },
{ value: NSEC, label: 'ns' },
{ value: USEC, label: 'us' },
{ value: MSEC, label: 'ms' },
{ value: SEC, label: 's' }]

export {
  getJitterEQDefaultValue,
  MAXIMAL_LENGTH_LFSR, USER_DEFINED_LFSR, USER_DEFINED_SEQUENCE,
  getTitleFromValue,
  NONE,
  PSEC,
  adsDelayList,
  JITTER_PDF_LIST
}